import { Link, NavLink, Outlet } from "react-router-dom";
import { UserButton } from "@clerk/clerk-react";
import {
  Compass,
  BookOpen,
  Settings,
  Sparkles,
  Target,
  Users,
} from "lucide-react";
import { cn } from "@/lib/cn";
import { useUserMe } from "@/lib/useUserMe";

const nav = [
  { to: "/app", icon: Compass, label: "Intelligence" },
  { to: "/app/briefings", icon: Sparkles, label: "Briefings" },
  { to: "/app/opportunities", icon: Target, label: "Opportunities" },
  { to: "/app/library", icon: BookOpen, label: "Library" },
  { to: "/app/circles", icon: Users, label: "Circles" },
];

export function AppShell() {
  const me = useUserMe();
  const isAdmin = me.data?.user?.role === "admin";
  return (
    <div className="min-h-dvh grid grid-cols-[260px_1fr]">
      <aside className="border-r border-veil/50 bg-ink/60 backdrop-blur-xl">
        <div className="px-6 py-7">
          <Link to="/app" className="flex items-baseline gap-2">
            <span className="font-display text-xl tracking-tight">CONNECT</span>
            <span className="label-eyebrow text-gold-glow">Intelligence OS</span>
          </Link>
        </div>
        <nav className="px-3 py-2 space-y-0.5">
          {nav.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/app"}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors",
                  isActive
                    ? "bg-veil/60 text-fog"
                    : "text-whisper hover:bg-veil/30 hover:text-fog",
                )
              }
            >
              <Icon className="size-4" strokeWidth={1.5} />
              {label}
            </NavLink>
          ))}
          {isAdmin && (
            <>
              <div className="mt-4 mb-1 px-3 text-[10px] uppercase tracking-[0.18em] text-muted">
                Operations
              </div>
              <NavLink
                to="/app/admin"
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors",
                    isActive
                      ? "bg-veil/60 text-fog"
                      : "text-whisper hover:bg-veil/30 hover:text-fog",
                  )
                }
              >
                <Settings className="size-4" strokeWidth={1.5} />
                Admin
              </NavLink>
            </>
          )}
        </nav>
        <div className="absolute bottom-0 left-0 w-[260px] border-t border-veil/50 p-4">
          <div className="flex items-center gap-3">
            <UserButton
              appearance={{
                elements: { avatarBox: "w-9 h-9" },
              }}
            />
            <div className="text-xs text-whisper">
              <div className="text-fog">Signed in</div>
              <div>premium</div>
            </div>
          </div>
        </div>
      </aside>
      <main className="relative overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
